import React from 'react';
import { Box } from '@common-fe/common-fe';

import { CompleteVerificationMessage } from '@/modules/core/components/Dashboard/components/BannersList/CompleteBanner';
import { TaxForms as TaxFormsList } from '@/modules/investments';

const TaxForms = () => {
  return (
    <Box  data-testId="tax-forms-tab">
      <Box margin={{ bottom: 'spacing24' }}>
        <CompleteVerificationMessage />
      </Box>
      <TaxFormsList />
    </Box>
  );
};

export default TaxForms;
